import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  @media ${({ theme }) => theme.device.mobile} {
    display: flex;
    flex-direction: column;
    background-color: ${ColorPalette.HEX.Lotion};
    height: 100vh;
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 26px 0 14px;
  background-color: ${ColorPalette.HEX.Lotion};
`;

export const FormContainer = styled(Form)`
  padding: 20px 16px 32px 16px;

  @media ${({ theme }) => theme.device.mobile} {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;

export const InfoContainer = styled.div``;

export const InfoLabel = styled.label`
  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.PineTree};
  margin-bottom: 8px;

  strong {
    font-weight: bold;
  }
`;
